'use client';

import Image from 'next/image';
import React, { FC, ImgHTMLAttributes, useState } from 'react';

type Props = ImgHTMLAttributes<any> & {
    src: string;
    width?: SafeNumber;
    height?: SafeNumber;
    alt: string;
    fill?: boolean;
    sizes?: string;
    quality?: SafeNumber;
    priority?: boolean;
    placeholder?: PlaceholderValue;
    //
    fallback?: string;
    // src	src="/profile.png"	String	Yes
    // width	width={500}	Integer (px)	Yes
    // height	height={500}	Integer (px)	Yes
    // alt	alt="Picture of the author"	String	Yes
    // loader	loader={imageLoader}	Function	-
    // fill	fill={true}	Boolean	-
    // sizes	sizes="(max-width: 768px) 100vw"	String	-
    // quality	quality={80}	Integer (1-100)	-
    // priority	priority={true}	Boolean	-
    // placeholder	placeholder="blur"	String	-
    // style	style={{objectFit: "contain"}}	Object	-
    // onLoadingComplete	onLoadingComplete={img => done())}	Function	-
    // onLoad	onLoad={event => done())}	Function	-
    // onError	onError(event => fail()}	Function	-
    // loading	loading="lazy"	String	-
    // blurDataURL	blurDataURL="data:image/jpeg..."	String
};
type SafeNumber = number | `${number}`;
type PlaceholderValue = 'blur' | 'empty';

const ImageWithFallback: FC<Props> = ({ fallback, src, alt, ...props }) => {
    const [imgSrc, setImgSrc] = useState<string>(src);
    const onError = () => fallback && setImgSrc(fallback);

    return (
        <Image
            src={imgSrc}
            // placeholder="blur"
            // blurDataURL={appIcons['image-wait-load.jpg']}
            onError={onError}
            alt={alt}
            height={0}
            width={0}
            className='h-auto w-full'
            priority
            {...props}
        />
    );
};

export default ImageWithFallback;
